export default __webpack_public_path__ + "static/media/lotnum-icon.c29638f8.svg";